import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";

import BasicTable from "componentsv2/table/BasicTable";
import Dialog from "componentsv2/modal/Dialog";
import SearchWidget from "componentsv2/widgets/SearchWidget";
import { useTable } from "storev2/tableStore";

/**
 * Define component search window
 * @param { Boolean } open - boolean
 * @param { Function } onClose - Callback function onClose
 * @param { String } model - string model tryton
 * @param { Array } layout - {ModelProduct.ctxView()}
 * @param { Function } onSelectedRecord - {() => onSelectedRecord()}
 * @returns Component search window
 */
function SearchWindow({
  onClose,
  layout,
  modeSelect,
  open,
  onSelectedRecord,
  title,
  storeId,
}) {
  const storeTable = useTable((state) => state?.[storeId]);
  const { presetTable, reload } = useTable();
  const recordStoreId = useSignal(null);

  async function acceptModal() {
    // console.log("On acceptModal....", storeTable.selected);
    const selected = Array.from(storeTable.selected.values());
    if (modeSelect === "multi") {
      onSelectedRecord(selected);
    } else {
      onSelectedRecord(selected[0]);
    }
    onClose();
  }

  function onDoubleClickRow(record) {
    if (record?.id) {
      onSelectedRecord(record);
      onClose();
    }
  }

  function onChangePage(page) {
    const limit = layout.limit ?? 20;
    const newOffset = (page - 1) * limit;
    reload(storeId, { offset: newOffset });
  }

  // function onClickRow(rec) {
  //   if (!rec) return;
  //   let selectedRows_ = new Map();
  //   if (modeSelect) {
  //     selectedRows_ = new Map(selectedRowsRef.current);
  //     if (selectedRows_.has(rec.id)) {
  //       selectedRows_.delete(rec.id);
  //     } else {
  //       selectedRows_.set(rec.id, rec);
  //     }
  //   }
  //   // selectedRowsRef.current = selectedRows_;
  //   // selectedRef.current = rec;
  // }

  const buttons = [
    {
      name: "close",
      onClick: onClose,
    },
    {
      name: "accept",
      onClick: acceptModal,
    },
  ];

  layout.selectable = true;

  useEffect(() => {
    presetTable(storeId, layout);
    console.log("Render do presetTable....", layout.model);
  }, [storeId]);

  return (
    <Dialog
      openModal={open}
      title={title}
      handleClose={onClose}
      buttons={buttons}
      size="w-full h-3/4 md:w-4/5"
    >
      <div className="md:w-1/2 my-4">
        <SearchWidget storeId={storeId} layout={layout} />
      </div>
      <BasicTable
        storeId={storeId}
        layout={layout}
        model={layout.model}
        records={storeTable?.records}
        limit={100}
        recordStoreId={recordStoreId}
        offset={storeTable?.offset ?? 0}
        onChangePage={onChangePage}
      />
    </Dialog>
  );
}

// selectable={modeSelect}
// onDoubleClickRow={onDoubleClickRow}
// onClickRow={onClickRow}

export default SearchWindow;
